import styled from "styled-components/macro"

export const Form = styled.form`
  display: flex;
  width: 100%;
`